<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <merus-data-table ref="notasFiscaisTable" :headers="headers" :items="notasFiscais" :loading="loading"
      :default-multi-sort="defaultSort" :loading-text="$t('notasFiscais.loading')" item-key="id_nota_fiscal"

 cod-tabela="NOTASFISCAIS" append-actions @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('notasFiscais.title')" :token="token" :items="notasFiscais"
          :pdf-title="$t('notasFiscais.title')" :pdf-headers="headers" :pdf-filename="$t('notasFiscais.title')"
          :csv-title="$t('notasFiscais.title')" :csv-headers="headersCsv" hide-search>
          <template v-slot:add>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="openDownloadQRDialog">
                  <v-icon>mdi-qrcode</v-icon>
                </v-btn>
              </template>
                <span>{{ $t('equipment.qrcode.downloadTitle') }}</span>
            </v-tooltip>
            <v-btn color="primary" dark small class="mb-2 mr-2" fab @click="openAddNota">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.nome_nota="{ item }">
        {{ item.nome_nota || '—' }}
      </template>
      <template v-slot:item.chave_nfe="{ item }">
        <span class="chave-nfe-cell">{{ item.chave_nfe || '—' }}</span>
      </template>
      <template v-slot:item.dt_emissao_extenso="{ item }">
        {{ item.dt_emissao_extenso || item.dt_emissao || '—' }}
      </template>
      <template v-slot:item.dt_cadastro_extenso="{ item }">
        {{ item.dt_cadastro_extenso || item.dt_cadastro || '—' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="primary" @click="openDetail(item)">mdi-eye</v-icon>
        <v-icon small class="mr-2" color="green" @click="openEditNota(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="confirmDeleteNota(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>

    <!-- Detail / Itens of selected NF -->
    <merus-data-table v-if="selectedNota" :headers="itemHeaders" :items="selectedNota.itens || []" :loading="false"
      item-key="id_item" class="mt-4" hide-default-footer

 cod-tabela="NOTASFISCAIS_ITEM" append-actions @update:headers="itemHeaders = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="itemsToolbarTitle" :token="token" :items="selectedNota.itens || []"
          :pdf-title="itemsToolbarTitle" :pdf-headers="itemHeaders" :pdf-filename="itemsToolbarTitle"
          :csv-title="itemsToolbarTitle" :csv-headers="itemHeaders" :csv-filename="itemsToolbarTitle" hide-search>
          <template v-slot:add>
            <!-- <HelpDialogCSV v-if="selectedNota.itens && selectedNota.itens.length" :fields="helpCsvFields"
              model="notasFiscais.uploadCsvEquipments.helpCsvModel" :data="[]" size="s" />
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-bind="attrs" v-on="on"
                  @click="openUploadCsvEquipments">
                  <v-icon>mdi-file-upload</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('notasFiscais.uploadCsvEquipments.titleTooltip') }}</span>
            </v-tooltip> -->
            <v-btn color="primary" dark small class="mb-2 mr-2" fab @click="selectedNota = null">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.q_cadastrados="{ item }">
        {{ insertedCountByItem[item.id_item] != null ? insertedCountByItem[item.id_item] :
          (item.q_equipamentos_vinculados != null ? item.q_equipamentos_vinculados : 0) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-center" style="gap: 4px;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon color="primary" v-bind="attrs" v-on="on"
                :disabled="insertedCountByItem[item.id_item] >= (item.q_com || 0)" @click="openInsertEquipment(item)">
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('notasFiscais.insertEquipmentFromItem') }}</span>
            <span v-if="insertedCountByItem[item.id_item] >= (item.q_com || 0)">
              — {{ $t('notasFiscais.insertEquipment.limitReached', {
                inserted: insertedCountByItem[item.id_item],
                limit:
                  item.q_com || 0
              }) }}
            </span>
          </v-tooltip>
        </div>
      </template>
    </merus-data-table>

    <!-- Add/Edit Nota Fiscal dialog -->
    <v-dialog v-model="notaDialog" persistent max-width="80vw">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ isEditNota ? $t('notasFiscais.editNotaFiscal') : $t('notasFiscais.addNotaFiscal')
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeNotaDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-file-input v-if="!isEditNota" v-model="xmlFile" :label="$t('notasFiscais.selectXml')" accept=".xml"
              prepend-icon="mdi-file-document" @change="onXmlSelected"></v-file-input>
            <v-text-field v-model="notaForm.nome_nota" :label="$t('notasFiscais.nomeNota')"
              :placeholder="$t('notasFiscais.nomeNotaPlaceholder')"></v-text-field>
            <v-text-field v-model="notaForm.chave_nfe" :label="$t('notasFiscais.chaveNfe')"
              :rules="[v => !!v || $t('notasFiscais.chaveNfeRequired')]"></v-text-field>
            <v-text-field v-model="notaForm.emit_cnpj" :label="$t('notasFiscais.emitCnpj')"></v-text-field>
            <v-text-field v-model="notaForm.dest_cnpj" :label="$t('notasFiscais.destCnpj')"></v-text-field>
            <v-text-field v-model="notaForm.dt_emissao" :label="$t('notasFiscais.dtEmissao')"></v-text-field>
            <v-divider class="my-4"></v-divider>
            <div class="text-subtitle-2">{{ $t('notasFiscais.items') }}</div>
            <v-simple-table v-if="(notaForm.itens || []).length" dense class="mt-2">
              <thead>
                <tr>
                  <th>{{ $t('notasFiscais.itemsHeaders.nItem') }}</th>
                  <th>{{ $t('notasFiscais.itemsHeaders.cProd') }}</th>
                  <th>{{ $t('notasFiscais.itemsHeaders.xProd') }}</th>
                  <th>{{ $t('notasFiscais.itemsHeaders.internalProduct') }}</th>
                  <th>{{ $t('notasFiscais.itemsHeaders.qCom') }}</th>
                  <th>{{ $t('notasFiscais.itemsHeaders.vProd') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in notaForm.itens" :key="row.n_item">
                  <td>{{ row.n_item }}</td>
                  <td>{{ row.c_prod }}</td>
                  <td>{{ row.x_prod }}</td>
                  <td>
                    <div class="d-flex align-center" style="gap: 6px;">
                      <v-autocomplete
                        v-model="row.id_produto_interno"
                        :items="produtosInternos"
                        :item-text="getProdutoInternoDisplay"
                        item-value="id_produto_interno"
                        dense
                        hide-details
                        :placeholder="$t('notasFiscais.internalProductRequired')"
                        class="pt-0 mt-0"
                        :rules="[v => !!v || $t('notasFiscais.internalProductRequired')]"
                      ></v-autocomplete>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="$router.push({ name: 'ProdutosInternos' })"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Criar novo produto interno</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td>{{ row.q_com }}</td>
                  <td>{{ row.v_prod }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNotaDialog">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="primary" :loading="savingNota" :disabled="!canSaveNota" @click="saveNota">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Insert Equipment dialog: cod_equipamento and modelo from selected internal product -->
    <v-dialog v-model="insertEquipmentDialog" persistent max-width="600">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('notasFiscais.insertEquipmentFromItem') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeInsertEquipmentDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <form @submit.prevent="saveInsertEquipment">
          <v-card-text>
            <v-container>
              <v-text-field v-model="insertEquipForm.nome_equipamento" :label="$t('equipment.name')"
                :rules="[v => !!v || $t('equipment.nameRequired')]"></v-text-field>
              <v-autocomplete v-model="insertEquipForm.id_tipo_equipamento" :items="tiposequipamentos"
                item-text="nome_tipo_equipamento" item-value="id_tipo_equipamento" :label="labelText('equipment.type')"
                :rules="[v => !!v || $t('equipment.typeRequired')]" :clearable="!insertEquipTypeLockedToItem"
                :disabled="insertEquipTypeLockedToItem" :readonly="insertEquipTypeLockedToItem"></v-autocomplete>
              <v-text-field v-model="insertEquipForm.numero_serie" :label="$t('equipment.serialNumber')"></v-text-field>
              <v-autocomplete v-model="insertEquipForm.id_empresa" :items="empresas" item-text="razao_social"
                item-value="id_empresa" :label="labelText('company.self', 1)"
                :rules="[v => !!v || $t('equipment.companyRequired')]" clearable></v-autocomplete>
              <v-autocomplete v-model="insertEquipForm.id_status_equipamento" :items="statusEquipamentos"
                item-text="descricao_status_equipamento" item-value="id_status_equipamento"
                :label="labelText('equipment.status')" clearable></v-autocomplete>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text type="button" @click="closeInsertEquipmentDialog">{{ $t('button.cancel') }}</v-btn>
            <v-btn color="primary" type="submit" :loading="savingInsertEquip">{{ $t('button.save') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <!-- Upload CSV equipments for item dialog -->
    <v-dialog v-model="uploadCsvDialog" persistent max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('notasFiscais.uploadCsvEquipments.title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeUploadCsvDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-alert type="info" dense class="mb-4">
              {{ $t('notasFiscais.uploadCsvEquipments.helpAllItems') }}
            </v-alert>
            <v-file-input v-model="csvFile" :label="$t('notasFiscais.uploadCsvEquipments.selectFile')"
              accept=".csv,.txt" prepend-icon="mdi-file-document-outline" clearable
              :disabled="uploadCsvLoading"></v-file-input>
            <v-progress-linear v-if="uploadCsvLoading" indeterminate color="primary" class="mt-2"></v-progress-linear>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeUploadCsvDialog">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="primary" :loading="uploadCsvLoading" :disabled="!csvFile || !csvFile.size"
            @click="processUploadCsv">{{ $t('button.upload') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResultDialogCSV :token="token || ''" :show="uploadCsvResultDialog" :headers="uploadCsvResultHeaders"
      :result="uploadCsvResult" @close="closeUploadCsvResultDialog" @save="closeUploadCsvResultDialog" />

      <DownloadQRDialog v-model="downloadQRDialogOpen" :token="token" />

    <!-- Confirm delete NF -->
    <v-dialog v-model="confirmDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t('system.alert') }}</v-card-title>
        <v-card-text>{{ deleteConfirmMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDeleteDialog = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="error" text @click="deleteNota">{{ $t('button.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>

import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import { parseNFeXml } from '@/utils/nfeParser';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import ResultDialogCSV from './Dialogs/ResultDialogCSV.vue';
// import HelpDialogCSV from './Dialogs/HelpDialogCSV.vue';
import DownloadQRDialog from "./Dialogs/DownloadQRDialog.vue";

export default {
  name: 'CRUDNotasFiscais',
  components: { 
    MerusDataTable, 
    CadastroToolbar, 
    ResultDialogCSV,
    DownloadQRDialog 
  },
  data() {
    return {
      itemHeaders: [],
      token: null,
      loading: true,
      notasFiscais: [],
      selectedNota: null,
      notaDialog: false,
      isEditNota: false,
      xmlFile: null,
      notaForm: {
        id_nota_fiscal: null,
        chave_nfe: '',
        nome_nota: '',
        emit_cnpj: '',
        dest_cnpj: '',
        dt_emissao: '',
        itens: []
      },
      savingNota: false,
      insertEquipmentDialog: false,
      insertEquipForm: {
        nome_equipamento: '',
        id_tipo_equipamento: null,
        id_produto_interno: null,
        cod_equipamento: '',
        modelo: '',
        numero_serie: '',
        id_empresa: null,
        id_status_equipamento: null
      },
      currentInsertItem: null,
      savingInsertEquip: false,
      insertedCountByItem: {},
      lastInsertedByItem: {},
      empresas: [],
      tiposequipamentos: [],
      produtosInternos: [],
      insertEquipFormCategoria: null,
      statusEquipamentos: [],
      confirmDeleteDialog: false,
      deleteConfirmMessage: '',
      notaToDelete: null,
      uploadCsvDialog: false,
      csvFile: null,
      uploadCsvLoading: false,
      uploadCsvResultDialog: false,
      uploadCsvResult: { error: false, result: [], arqlog: '' },
      downloadQRDialogOpen: false,
      savingTipoCategoriaId: null
    };
  },
  computed: {
    /** True when the current fiscal note item has a type set, so Insert Equipment must use that type. */
    insertEquipTypeLockedToItem() {
      const item = this.currentInsertItem;
      return !!(item && item.id_tipo_equipamento);
    },
    /** Internal products filtered by the current note item's equipment type (for Insert Equipment dialog). */
    produtosInternosFilteredByInsertItem() {
      const item = this.currentInsertItem;
      const idTipo = item && item.id_tipo_equipamento;
      if (!idTipo || !this.produtosInternos || !this.produtosInternos.length) return this.produtosInternos || [];
      return this.produtosInternos.filter((p) => p.id_tipo_equipamento === idTipo);
    },
    /** Save button enabled only when chave_nfe is set and every item has an internal product. */
    canSaveNota() {
      if (!this.notaForm.chave_nfe || !this.notaForm.chave_nfe.trim()) return false;
      const itens = this.notaForm.itens || [];
      return itens.length === 0 || itens.every((i) => !!i.id_produto_interno);
    },
    itemsToolbarTitle() {
      if (!this.selectedNota) return this.$t('notasFiscais.items');
      return `${this.$t('notasFiscais.items')} — ${this.selectedNota.nome_nota || this.selectedNota.chave_nfe || ''}`;
    },
    uploadCsvResultHeaders() {
      return [
        { text: this.$t('notasFiscais.uploadCsvEquipments.resultLine'), value: 'line_number', error: 'error_line' },
        { text: this.$t('equipment.name'), value: 'nome_equipamento', error: 'error_line' },
        { text: this.$t('notasFiscais.uploadCsvEquipments.resultError'), value: 'error_line', error: 'error_line' }
      ];
    },
    helpCsvFields() {
      return [
        { label: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.type.label'), description: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.type.description'), example: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.type.example'), key: 'nome_tipo_equipamento' },
        { label: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.name.label'), description: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.name.description'), example: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.name.example'), key: 'nome_equipamento' },
        { label: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.serialNumber.label'), description: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.serialNumber.description'), example: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.serialNumber.example'), key: 'numero_serie' },
        { label: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.company.label'), description: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.company.description'), example: this.$t('notasFiscais.uploadCsvEquipments.helpCsv.company.example'), key: 'cod_empresa' }
      ];
    },
    defaultSort() {
      return [
        { value: 'dt_cadastro_extenso', options: { text: this.$t('system.labels.decreasing'), value: -1 } }
      ];
    },
    categoriasTipoEquipamento() {
      const tipos = this.tiposequipamentos || [];
      const set = new Set();
      tipos.forEach((t) => {
        const c = t.categoria_tipo_equipamento != null && String(t.categoria_tipo_equipamento).trim() !== '' ? String(t.categoria_tipo_equipamento).trim() : null;
        if (c) set.add(c);
      });
      return Array.from(set).sort().map((c) => ({ categoria: c }));
    },
    tiposequipamentosFiltradosPorCategoria() {
      const tipos = this.tiposequipamentos || [];
      const cat = this.insertEquipFormCategoria;
      if (!cat) return tipos;
      return tipos.filter((t) => (t.categoria_tipo_equipamento || '').trim() === cat);
    },
    /** Equipment types that have no category (used as "category" options in nota itens table) */
    tiposequipamentosSemCategoria() {
      const tipos = this.tiposequipamentos || [];
      return tipos.filter((t) => !(t.categoria_tipo_equipamento != null && String(t.categoria_tipo_equipamento).trim() !== ''));
    },
    headersCsv() {
      return [
        { text: this.$t('notasFiscais.headers.idNotaFiscal'), value: 'id_nota_fiscal' },
        { text: this.$t('notasFiscais.headers.nomeNota'), value: 'nome_nota' },
        { text: this.$t('notasFiscais.headers.chaveNfe'), value: 'chave_nfe' },
        { text: this.$t('notasFiscais.headers.emitCnpj'), value: 'emit_cnpj' },
        { text: this.$t('notasFiscais.headers.destCnpj'), value: 'dest_cnpj' },
        { text: this.$t('notasFiscais.headers.dtEmissao'), value: 'dt_emissao_extenso' },
        { text: this.$t('notasFiscais.headers.dtCadastro'), value: 'dt_cadastro_extenso' }
      ];
    },
  },
  created() {
    this.token = sessionStorage.getItem('api');
    this.loadNotas();
    this.loadEmpresas();
    this.loadTiposEquipamentos();
    this.loadProdutosInternos();
    this.loadStatusEquipamentos();
  },
  mounted() {
    this._escHandler = (e) => {
      if (e.key !== 'Escape') return;
      if (this.insertEquipmentDialog) this.closeInsertEquipmentDialog();
      else if (this.uploadCsvDialog) this.closeUploadCsvDialog();
    };
    window.addEventListener('keydown', this._escHandler);
  },
  beforeDestroy() {
    if (this._escHandler) window.removeEventListener('keydown', this._escHandler);
  },
  methods: {

    /** Ensures label is always a string (VAutocomplete expects String; $t/$tc can sometimes return Object). */
    labelText(key, tcCount) {
      const v = tcCount !== undefined ? this.$tc(key, tcCount) : this.$t(key);
      if (typeof v === 'string') return v;
      if (v && typeof v === 'object' && typeof v.label === 'string') return v.label;
      return key;
    },
    loadNotas() {
      this.loading = true;
      apiController.request(apiController.endpoints.getallNotasfiscais, {
        onSuccess: (response) => {
          const data = response.data;
          this.notasFiscais = Array.isArray(data)
            ? data
            : (data && Array.isArray(data.data) ? data.data : (data && Array.isArray(data.rows) ? data.rows : []));
          this.loading = false;
          console.log(this.notasFiscais);
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    loadEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => { this.empresas = response.data || []; },
      });
    },
    async loadTiposEquipamentos() {
      try {
        const response = await apiController.request(apiController.endpoints.getallTiposequipamentos, { silent: true });
        this.tiposequipamentos = response.data || [];
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    loadProdutosInternos() {
      apiController.request(apiController.endpoints.getallProdutosinternos, {
        onSuccess: (response) => { this.produtosInternos = response.data || []; },
      });
    },
    getProdutoInternoById(id) {
      if (id == null || !this.produtosInternos || !this.produtosInternos.length) return null;
      return this.produtosInternos.find((p) => p.id_produto_interno === id) || null;
    },
    getProdutoInternoDisplay(p) {
      if (!p) return '';
      const cod = p.codigo_interno || '';
      const tipo = p.nome_tipo_equipamento ? ' — ' + p.nome_tipo_equipamento : '';
      return cod + tipo;
    },
    /**
     * Build cod_equipamento as: full product code + sequence (NN = 2 digits, or more if >= 100).
     * Must match backend buildCodEquipamento so form preview matches saved value.
     */
    formatCodEquipamento(codigoInterno, nextSequence) {
      const productPart = (codigoInterno != null ? String(codigoInterno).trim() : '') || '0';
      const seq = Math.max(1, parseInt(nextSequence, 10) || 1);
      const seqDigits = seq >= 100 ? String(seq).length : 2;
      const sequencePart = String(seq).padStart(seqDigits, '0');
      return productPart + sequencePart;
    },
    /** Next sequence number for the current NF item (how many equipments already inserted + 1). */
    getNextSequenceForCurrentItem() {
      if (!this.currentInsertItem) return 1;
      const idItem = this.currentInsertItem.id_item;
      const count = this.insertedCountByItem[idItem] != null ? Number(this.insertedCountByItem[idItem]) : 0;
      return count + 1;
    },
    /** When internal product is selected in Insert Equipment dialog, fill cod_equipamento and modelo from product. */
    onInsertEquipProdutoInternoChange(idProduto) {
      const p = this.getProdutoInternoById(idProduto);
      if (p) {
        const codigoInterno = (p.codigo_interno || '').trim();
        const nextSeq = this.getNextSequenceForCurrentItem();
        this.insertEquipForm.cod_equipamento = this.formatCodEquipamento(codigoInterno, nextSeq);
        this.insertEquipForm.modelo = (p.modelo != null && String(p.modelo).trim() !== '') ? String(p.modelo).trim() : '';
      } else {
        this.insertEquipForm.cod_equipamento = '';
        this.insertEquipForm.modelo = '';
      }
    },
    getTipoForItem(row) {
      if (!row || !row.x_prod || !this.tiposequipamentos || !this.tiposequipamentos.length) return null;
      const x = String(row.x_prod).trim().toLowerCase();
      if (!x) return null;
      return this.tiposequipamentos.find((t) => (t.nome_tipo_equipamento || '').trim().toLowerCase() === x) || null;
    },
    getTipoById(id) {
      if (id == null || !this.tiposequipamentos || !this.tiposequipamentos.length) return null;
      return this.tiposequipamentos.find((t) => t.id_tipo_equipamento === id) || null;
    },
    /** Autocomplete options for categoria_tipo_equipamento: types without category + the type that is the current category (so it shows in the list). */
    getTipoCategoriaOptionsForItem(row) {
      const tipo = this.getTipoForItem(row);
      return this.getTipoCategoriaOptionsForTipo(tipo);
    },
    getTipoCategoriaOptionsForTipo(tipo) {
      if (!tipo) return this.tiposequipamentosSemCategoria || [];
      const semCat = this.tiposequipamentosSemCategoria || [];
      const catVal = tipo.categoria_tipo_equipamento;
      if (catVal == null || String(catVal).trim() === '') return semCat;
      const catId = typeof catVal === 'number' ? catVal : parseInt(String(catVal).trim(), 10);
      if (isNaN(catId)) return semCat;
      const alreadyIn = semCat.some((t) => t.id_tipo_equipamento === catId);
      if (alreadyIn) return semCat;
      const tipoCategoria = (this.tiposequipamentos || []).find((t) => t.id_tipo_equipamento === catId);
      if (!tipoCategoria) return semCat;
      return [tipoCategoria, ...semCat];
    },
    /** Value for the categoria autocomplete so it matches item-value (id_tipo_equipamento, number). */
    getTipoCategoriaValueForSelect(tipo) {
      if (!tipo || tipo.categoria_tipo_equipamento == null || String(tipo.categoria_tipo_equipamento).trim() === '') return null;
      const raw = tipo.categoria_tipo_equipamento;
      const num = typeof raw === 'number' ? raw : parseInt(String(raw).trim(), 10);
      return isNaN(num) ? raw : num;
    },
    onTipoCategoriaChangeFromItem(tipo, val) {
      if (!tipo) return;
      tipo.categoria_tipo_equipamento = val != null && String(val).trim() !== '' ? String(val).trim() : null;
      this.onTipoCategoriaChange(tipo, val);
    },
    onTipoCategoriaChange(tipo, valueFromInput) {
      const id = tipo.id_tipo_equipamento;
      const raw = valueFromInput !== undefined ? valueFromInput : tipo.categoria_tipo_equipamento;
      const categoria = raw != null && String(raw).trim() !== ''
        ? String(raw).trim()
        : null;
      this.savingTipoCategoriaId = id;
      const payload = { id_tipo_equipamento: id, categoria_tipo_equipamento: categoria };
      apiController.request(apiController.endpoints.updateTipoequipamento, {
        data: payload,
        onSuccess: (response) => {
          this.savingTipoCategoriaId = null;
          if (response.data && response.data.erro) {
            EventBus.$emit('show-error', { message: response.data.mensagem || 'Erro ao atualizar categoria' });
            this.loadTiposEquipamentos();
            return;
          }
          this.loadTiposEquipamentos();
          EventBus.$emit('show-success', { message: this.$t('button.saved') || 'Salvo.' });
        },
        onError: () => {
          this.savingTipoCategoriaId = null;
          this.loadTiposEquipamentos();
        },
      });
    },
    loadStatusEquipamentos() {
      apiController.request(apiController.endpoints.getallStatusequipamento, {
        onSuccess: (response) => { this.statusEquipamentos = response.data || []; },
      });
    },
    openDetail(item) {
      apiController.request(apiController.endpoints.getNotafiscalbyid, {
        params: { id: item.id_nota_fiscal },
        onSuccess: (response) => {
          this.selectedNota = response.data;
          const byItem = {};
          (this.selectedNota.itens || []).forEach((i) => {
            byItem[i.id_item] = i.q_equipamentos_vinculados != null ? Number(i.q_equipamentos_vinculados) : 0;
          });
          this.insertedCountByItem = { ...this.insertedCountByItem, ...byItem };
        },
      });
    },
    openAddNota() {
      this.isEditNota = false;
      this.notaForm = { id_nota_fiscal: null, chave_nfe: '', nome_nota: '', emit_cnpj: '', dest_cnpj: '', dt_emissao: '', itens: [] };
      this.xmlFile = null;
      this.notaDialog = true;
    },
    openEditNota(item) {
      apiController.request(apiController.endpoints.getNotafiscalbyid, {
        params: { id: item.id_nota_fiscal },
        onSuccess: (response) => {
          const nf = response.data;
          this.isEditNota = true;
          const produtos = this.produtosInternos || [];
          this.notaForm = {
            id_nota_fiscal: nf.id_nota_fiscal,
            chave_nfe: nf.chave_nfe || '',
            nome_nota: nf.nome_nota || '',
            emit_cnpj: nf.emit_cnpj || '',
            dest_cnpj: nf.dest_cnpj || '',
            dt_emissao: nf.dt_emissao || '',
            itens: (nf.itens || []).map((i) => {
              const idTipo = i.id_tipo_equipamento;
              const firstProdutoWithTipo = idTipo ? produtos.find((p) => p.id_tipo_equipamento === idTipo) : null;
              return {
                id_item: i.id_item,
                n_item: i.n_item,
                c_prod: i.c_prod,
                x_prod: i.x_prod,
                q_com: i.q_com,
                v_un_com: i.v_un_com,
                v_prod: i.v_prod,
                id_produto_interno: firstProdutoWithTipo ? firstProdutoWithTipo.id_produto_interno : null
              };
            })
          };
          this.notaDialog = true;
        },
      });
    },
    onXmlSelected(file) {
      if (!file || !file.size) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target && e.target.result;
          if (!text) {
            EventBus.$emit('show-error', { message: this.$t('notasFiscais.fileEmpty') });
            return;
          }
          const parsed = parseNFeXml(text);
          this.notaForm.chave_nfe = parsed.chave_nfe || '';
          this.notaForm.emit_cnpj = parsed.emit_cnpj || '';
          this.notaForm.dest_cnpj = parsed.dest_cnpj || '';
          this.notaForm.dt_emissao = parsed.dt_emissao || '';
          this.notaForm.itens = (parsed.itens || []).map((it) => ({
            n_item: it.n_item,
            c_prod: it.c_prod,
            x_prod: it.x_prod,
            q_com: it.q_com,
            v_un_com: it.v_un_com,
            v_prod: it.v_prod,
            id_produto_interno: null
          }));
        } catch (err) {
          EventBus.$emit('show-error', { message: this.$t('notasFiscais.parseError') + ' ' + (err.message || '') });
        }
      };
      reader.onerror = () => EventBus.$emit('show-error', { message: this.$t('notasFiscais.readError') });
      reader.readAsText(file);
    },
    closeNotaDialog() {
      this.notaDialog = false;
      this.notaForm = { id_nota_fiscal: null, chave_nfe: '', nome_nota: '', emit_cnpj: '', dest_cnpj: '', dt_emissao: '', itens: [] };
      this.xmlFile = null;
    },
    saveNota() {
      if (!this.notaForm.chave_nfe || !this.notaForm.chave_nfe.trim()) {
        EventBus.$emit('show-error', { message: this.$t('notasFiscais.chaveNfeRequired') });
        return;
      }
      const itens = this.notaForm.itens || [];
      const firstWithoutProduto = itens.find((i) => !i.id_produto_interno);
      if (firstWithoutProduto) {
        EventBus.$emit('show-error', { message: this.$t('notasFiscais.internalProductRequired') + ' (' + (firstWithoutProduto.x_prod || firstWithoutProduto.n_item) + ')' });
        return;
      }
      const itensWithTipo = itens.map((i) => {
        const prod = this.getProdutoInternoById(i.id_produto_interno);
        return { ...i, id_tipo_equipamento: prod ? prod.id_tipo_equipamento : null };
      });
      const firstWithoutTipo = itensWithTipo.find((i) => !i.id_tipo_equipamento);
      if (firstWithoutTipo) {
        EventBus.$emit('show-error', { message: this.$t('notasFiscais.internalProductRequired') });
        return;
      }
      this.savingNota = true;
      const payload = {
        chave_nfe: this.notaForm.chave_nfe,
        nome_nota: this.notaForm.nome_nota || null,
        emit_cnpj: this.notaForm.emit_cnpj || null,
        dest_cnpj: this.notaForm.dest_cnpj || null,
        dt_emissao: this.notaForm.dt_emissao || null,
        itens: itensWithTipo.map((i) => ({
          n_item: i.n_item,
          c_prod: i.c_prod,
          x_prod: i.x_prod,
          q_com: i.q_com,
          v_un_com: i.v_un_com,
          v_prod: i.v_prod,
          id_tipo_equipamento: i.id_tipo_equipamento || null
        }))
      };
      const isEdit = this.isEditNota && this.notaForm.id_nota_fiscal;
      const reqOptions = {
        onSuccess: (response) => {
          this.savingNota = false;
          if (response.data && response.data.erro) {
            EventBus.$emit('show-error', { message: response.data.mensagem || (isEdit ? this.$t('notasFiscais.updateTable.error.update') : this.$t('notasFiscais.updateTable.error.insert')) });
            return;
          }
          EventBus.$emit('show-success', { message: isEdit ? this.$t('notasFiscais.updateTable.success.update') : this.$t('notasFiscais.updateTable.success.insert') });
          this.closeNotaDialog();
          this.loadNotas();
        },
        onError: () => {
          this.savingNota = false;
        },
      };
      if (isEdit) {
        apiController.request(apiController.endpoints.updateNotafiscal, { data: { ...payload, id_nota_fiscal: this.notaForm.id_nota_fiscal }, ...reqOptions });
      } else {
        apiController.request(apiController.endpoints.insertNotafiscal, { data: payload, ...reqOptions });
      }
    },
    confirmDeleteNota(item) {
      this.notaToDelete = item;
      this.deleteConfirmMessage = this.$t('notasFiscais.confirmDelete', { chave: item.chave_nfe });
      this.confirmDeleteDialog = true;
    },
    deleteNota() {
      if (!this.notaToDelete) return;
      const id = this.notaToDelete.id_nota_fiscal;
      this.confirmDeleteDialog = false;
      apiController.request(apiController.endpoints.deleteNotafiscal, {
        data: { id_nota_fiscal: id },
        onSuccess: (response) => {
          if (response.data && response.data.erro) {
            EventBus.$emit('show-error', { message: response.data.mensagem || this.$t('notasFiscais.updateTable.error.delete') });
            return;
          }
          EventBus.$emit('show-success', { message: this.$t('notasFiscais.updateTable.success.delete') });
          this.notaToDelete = null;
          this.selectedNota = null;
          this.loadNotas();
        },
      });
    },
    openInsertEquipment(item) {
      const limit = item.q_com != null ? Number(item.q_com) : 0;
      const count = this.insertedCountByItem[item.id_item] || 0;
      if (count >= limit) return;
      this.currentInsertItem = item;
      // Use the type defined for this fiscal note item (saved when the note was created/edited)
      const tipos = this.tiposequipamentos || [];
      const idTipoFromItem = item.id_tipo_equipamento && tipos.some((t) => t.id_tipo_equipamento === item.id_tipo_equipamento)
        ? item.id_tipo_equipamento
        : null;
      const descricao = (item.x_prod || '').toString().trim();
      const matchedTipo = descricao && (
        tipos.find((t) => (t.nome_tipo_equipamento || '').toLowerCase() === descricao.toLowerCase()) ||
        tipos.find((t) => {
          const nome = (t.nome_tipo_equipamento || '').toLowerCase();
          const desc = descricao.toLowerCase();
          return nome && desc && (desc.includes(nome) || nome.includes(desc));
        })
      );
      const idTipoFromDescricao = matchedTipo ? matchedTipo.id_tipo_equipamento : null;
      const idTipo = idTipoFromItem || idTipoFromDescricao;
      const produtosFiltrados = idTipo ? (this.produtosInternos || []).filter((p) => p.id_tipo_equipamento === idTipo) : [];
      const firstProduto = produtosFiltrados.length ? produtosFiltrados[0] : null;
      const nextSeq = this.getNextSequenceForCurrentItem();
      const codigoBase = firstProduto ? (firstProduto.codigo_interno || '').trim() : '';
      this.insertEquipForm = {
        nome_equipamento: '',
        id_tipo_equipamento: idTipo,
        id_produto_interno: firstProduto ? firstProduto.id_produto_interno : null,
        cod_equipamento: firstProduto ? this.formatCodEquipamento(codigoBase, nextSeq) : '',
        modelo: firstProduto && firstProduto.modelo != null && String(firstProduto.modelo).trim() !== '' ? String(firstProduto.modelo).trim() : '',
        numero_serie: '',
        id_empresa: null,
        id_status_equipamento: 0
      };
      this.insertEquipmentDialog = true;
    },
    closeInsertEquipmentDialog() {
      this.insertEquipmentDialog = false;
      this.currentInsertItem = null;
      this.insertEquipFormCategoria = null;
      this.insertEquipForm = {
        nome_equipamento: '',
        id_tipo_equipamento: null,
        id_produto_interno: null,
        cod_equipamento: '',
        modelo: '',
        numero_serie: '',
        id_empresa: null,
        id_status_equipamento: null
      };
    },
    onInsertEquipCategoriaChange() {
      const filtered = this.tiposequipamentosFiltradosPorCategoria || [];
      const id = this.insertEquipForm.id_tipo_equipamento;
      if (id && !filtered.some((t) => t.id_tipo_equipamento === id)) {
        this.insertEquipForm.id_tipo_equipamento = null;
      }
    },
    resetInsertEquipFormForSameItem() {
      if (!this.currentInsertItem) return;
      const item = this.currentInsertItem;
      const tipos = this.tiposequipamentos || [];
      const idTipoFromItem = item.id_tipo_equipamento && tipos.some((t) => t.id_tipo_equipamento === item.id_tipo_equipamento)
        ? item.id_tipo_equipamento
        : null;
      const descricao = (item.x_prod || '').toString().trim();
      const matched = descricao && (
        tipos.find((t) => (t.nome_tipo_equipamento || '').toLowerCase() === descricao.toLowerCase()) ||
        tipos.find((t) => {
          const nome = (t.nome_tipo_equipamento || '').toLowerCase();
          const desc = descricao.toLowerCase();
          return nome && desc && (desc.includes(nome) || nome.includes(desc));
        })
      );
      const idTipo = idTipoFromItem || (matched ? matched.id_tipo_equipamento : null);
      const produtosFiltrados = idTipo ? (this.produtosInternos || []).filter((p) => p.id_tipo_equipamento === idTipo) : [];
      const firstProduto = produtosFiltrados.length ? produtosFiltrados[0] : null;
      const nextSeq = this.getNextSequenceForCurrentItem();
      const codigoBase = firstProduto ? (firstProduto.codigo_interno || '').trim() : '';
      this.insertEquipForm = {
        nome_equipamento: '',
        id_tipo_equipamento: idTipo,
        id_produto_interno: firstProduto ? firstProduto.id_produto_interno : null,
        cod_equipamento: firstProduto ? this.formatCodEquipamento(codigoBase, nextSeq) : '',
        modelo: firstProduto && firstProduto.modelo != null && String(firstProduto.modelo).trim() !== '' ? String(firstProduto.modelo).trim() : '',
        numero_serie: '',
        id_empresa: this.insertEquipForm.id_empresa,
        id_status_equipamento: 0
      };
    },
    async saveInsertEquipment() {
      if (!this.currentInsertItem) return;
      if (!this.insertEquipForm.nome_equipamento || !this.insertEquipForm.id_empresa || !this.insertEquipForm.id_tipo_equipamento || !this.insertEquipForm.id_produto_interno) {
        EventBus.$emit('show-error', { message: this.$t('notasFiscais.insertEquipment.error') });
        return;
      }
      // Backend computes cod_equipamento (product code + sequence) when id_item and id_produto_interno are sent
      this.savingInsertEquip = true;
      const idNotaFiscal = this.selectedNota && this.selectedNota.id_nota_fiscal;
      const idItem = this.currentInsertItem ? this.currentInsertItem.id_item : null;
      const payload = {
        nome_equipamento: this.insertEquipForm.nome_equipamento,
        cod_equipamento: (this.insertEquipForm.cod_equipamento || '').trim() || null,
        modelo: (this.insertEquipForm.modelo || '').trim() || null,
        id_tipo_equipamento: this.insertEquipForm.id_tipo_equipamento,
        numero_serie: this.insertEquipForm.numero_serie || null,
        id_empresa: this.insertEquipForm.id_empresa,
        id_status_equipamento: this.insertEquipForm.id_status_equipamento || null,
        ativo: 0,
        id_nota_fiscal: idNotaFiscal || null,
        id_item: idItem || null,
        id_produto_interno: this.insertEquipForm.id_produto_interno || null
      };
      try {
        const response = await apiController.request(apiController.endpoints.insertEquipamento, { data: payload, silent: true });
        if (response.data && response.data.erro) {
          this.savingInsertEquip = false;
          const msg = response.data.mensagem || this.$t('notasFiscais.insertEquipment.error');
          EventBus.$emit('show-error', { error: { message: msg } });
          return;
        }
        const idItem = this.currentInsertItem.id_item;
        const idEquipamento = response.data.id_equipamento;
        const limit = this.currentInsertItem.q_com != null ? Number(this.currentInsertItem.q_com) : 0;
        if (idEquipamento) {
          this.lastInsertedByItem = { ...this.lastInsertedByItem, [idItem]: idEquipamento };
          const linkRes = await apiController.request(apiController.endpoints.insertNotafiscalitemequipamento, { data: { id_item: idItem, id_equipamento: idEquipamento }, silent: true });
          this.savingInsertEquip = false;
          if (linkRes.data && linkRes.data.erro) {
            const linkMsg = linkRes.data.mensagem || this.$t('notasFiscais.insertEquipment.error');
            EventBus.$emit('show-error', { error: { message: linkMsg } });
            return;
          }
          this.insertedCountByItem = { ...this.insertedCountByItem, [idItem]: (this.insertedCountByItem[idItem] || 0) + 1 };
          EventBus.$emit('show-success', { message: this.$t('notasFiscais.insertEquipment.success') });
          EventBus.$emit('show-alert', { mensagem: this.$t('notasFiscais.insertEquipment.success'), tipo: 'success' });
          if (this.insertedCountByItem[idItem] >= limit) {
            this.closeInsertEquipmentDialog();
          } else {
            this.resetInsertEquipFormForSameItem();
          }
        } else {
          this.savingInsertEquip = false;
          this.insertedCountByItem = { ...this.insertedCountByItem, [idItem]: (this.insertedCountByItem[idItem] || 0) + 1 };
          EventBus.$emit('show-success', { message: this.$t('notasFiscais.insertEquipment.success') });
          EventBus.$emit('show-alert', { mensagem: this.$t('notasFiscais.insertEquipment.success'), tipo: 'success' });
          if (this.insertedCountByItem[idItem] >= limit) {
            this.closeInsertEquipmentDialog();
          } else {
            this.resetInsertEquipFormForSameItem();
          }
        }
      } catch (e) {
        this.savingInsertEquip = false;
        EventBus.$emit('show-error', { error: e });
      }
    },
    getTipoEquipamentoIdFromLineDescription(descricao) {
      if (!descricao || typeof descricao !== 'string') return null;
      const d = descricao.trim().toLowerCase();
      if (!d) return null;
      const tipos = this.tiposequipamentos || [];
      const exact = tipos.find((t) => (t.nome_tipo_equipamento || '').toLowerCase() === d);
      if (exact) return exact.id_tipo_equipamento;
      const partial = tipos.find((t) => {
        const nome = (t.nome_tipo_equipamento || '').toLowerCase();
        return nome && (d.includes(nome) || nome.includes(d));
      });
      return partial ? partial.id_tipo_equipamento : null;
    },
    openUploadCsvEquipments() {
      if (!this.selectedNota || !(this.selectedNota.itens || []).length) return;
      this.csvFile = null;
      this.uploadCsvDialog = true;
    },
    closeUploadCsvDialog() {
      this.uploadCsvDialog = false;
      this.csvFile = null;
    },
    closeUploadCsvResultDialog() {
      this.uploadCsvResultDialog = false;
      this.uploadCsvResult = { error: false, result: [], arqlog: '' };
      if (this.selectedNota) this.openDetail(this.selectedNota);
    },
    parseCsvText(text) {
      const raw = (text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
      if (!raw) return { rows: [], hasHeader: false };
      const lines = raw.split('\n').filter((l) => l.trim().length > 0);
      const sep = raw.includes(';') ? ';' : ',';
      let rows = lines.map((line) => {
        const cells = line.split(sep).map((c) => (c || '').replace(/^["']|["']$/g, '').trim());
        return cells;
      });
      const first = rows[0] || [];
      const firstLower = (first[0] || '').toLowerCase();
      const isTypeHeader = firstLower === 'tipo' || firstLower === 'nome_tipo_equipamento' || firstLower === 'type' || firstLower === 'descrição' || firstLower === 'descricao';
      const isItemIdHeader = firstLower === 'n_item' || firstLower === 'c_prod' || firstLower === 'x_prod' || firstLower === 'item' || firstLower === 'numero' || firstLower === 'nº item';
      const isNameHeader = firstLower === 'nome_equipamento' || firstLower === 'name' || firstLower === 'nome' || firstLower === 'equipamento';
      const hasHeader = isTypeHeader || isItemIdHeader || isNameHeader;
      const dataRows = hasHeader ? rows.slice(1) : rows;
      return { rows: dataRows, hasHeader, sep };
    },
    /** Normalize dimension-like suffix so "28MM" matches "2.8MM" (CSV often drops decimal). */
    normalizeDimensionMM(str) {
      if (!str || typeof str !== 'string') return str;
      return str.replace(/(\d)(\d)MM\b/i, '$1.$2MM');
    },
    findItemByIdentifier(identifier) {
      if (!this.selectedNota || !this.selectedNota.itens || !identifier) return null;
      const itens = this.selectedNota.itens;
      const v = String(identifier).trim();
      if (!v) return null;
      const asNum = Number(v);
      if (!Number.isNaN(asNum)) {
        const byNItem = itens.find((i) => Number(i.n_item) === asNum);
        if (byNItem) return byNItem;
      }
      const byCProd = itens.find((i) => String(i.c_prod || '').trim() === v);
      if (byCProd) return byCProd;
      const vLower = v.toLowerCase();
      const byXProd = itens.find((i) => (i.x_prod || '').toString().trim().toLowerCase() === vLower);
      if (byXProd) return byXProd;
      const partial = itens.find((i) => (i.x_prod || '').toString().toLowerCase().includes(vLower));
      if (partial) return partial;
      const vNorm = this.normalizeDimensionMM(v).toLowerCase();
      if (vNorm !== vLower) {
        const byNorm = itens.find((i) => this.normalizeDimensionMM((i.x_prod || '').toString().trim()).toLowerCase() === vNorm);
        if (byNorm) return byNorm;
        const partialNorm = itens.find((i) => this.normalizeDimensionMM((i.x_prod || '').toString().trim()).toLowerCase().includes(vNorm));
        if (partialNorm) return partialNorm;
      }
      return null;
    },
    /** Find first NF item whose x_prod matches the type (with normalization) and that has capacity. */
    findItemByType(tipoName) {
      if (!this.selectedNota || !this.selectedNota.itens || !tipoName) return null;
      const itens = this.selectedNota.itens;
      const v = String(tipoName).trim();
      if (!v) return null;
      const vLower = v.toLowerCase();
      const vNorm = this.normalizeDimensionMM(v).toLowerCase();
      const matches = itens.filter((i) => {
        const x = (i.x_prod || '').toString().trim().toLowerCase();
        const xNorm = this.normalizeDimensionMM((i.x_prod || '').toString().trim()).toLowerCase();
        const match = x === vLower || xNorm === vNorm || x.includes(vLower) || xNorm.includes(vNorm) || vLower.includes(x) || vNorm.includes(xNorm);
        if (!match) return false;
        const limit = i.q_com != null ? Number(i.q_com) : 0;
        const count = this.insertedCountByItem[i.id_item] || 0;
        return count < limit;
      });
      return matches.length ? matches[0] : null;
    },
    resolveIdEmpresaFromCell(cell) {
      if (!cell || !String(cell).trim()) return null;
      const v = String(cell).trim();
      const byId = this.empresas.find((e) => String(e.id_empresa) === v);
      if (byId) return byId.id_empresa;
      const byRazao = this.empresas.find((e) => (e.razao_social || '').toLowerCase() === v.toLowerCase());
      if (byRazao) return byRazao.id_empresa;
      const partial = this.empresas.find((e) => (e.razao_social || '').toLowerCase().includes(v.toLowerCase()));
      if (partial) return partial.id_empresa;
      return null;
    },
    async processUploadCsv() {
      if (!this.selectedNota || !(this.selectedNota.itens || []).length || !this.csvFile || !this.csvFile.size) return;
      this.uploadCsvLoading = true;
      const resultRows = [];
      let hasError = false;
      let totalInserted = 0;
      const readFile = () =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve((e.target && e.target.result) || '');
          reader.onerror = () => reject(new Error('File read error'));
          reader.readAsText(this.csvFile, 'UTF-8');
        });
      try {
        let text = await readFile();
        if (text.charCodeAt(0) === 0xfeff) text = text.slice(1);
        const { rows } = this.parseCsvText(text);
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];
          const tipoName = (row[0] || '').toString().trim();
          const nome = (row[1] || '').toString().trim();
          const numCols = row.length;
          const numeroSerie = numCols > 3 ? ((row[2] || '').toString().trim() || null) : null;
          const empresaCell = numCols > 3 ? row[3] : row[2];
          if (!tipoName) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome || '—', error_line: this.$t('notasFiscais.uploadCsvEquipments.errorTypeRequired') });
            hasError = true;
            continue;
          }
          const item = this.findItemByType(tipoName);
          if (!item) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome || '—', error_line: this.$t('notasFiscais.uploadCsvEquipments.errorItemNotFoundByType', { tipo: tipoName }) });
            hasError = true;
            continue;
          }
          const limit = item.q_com != null ? Number(item.q_com) : 0;
          const currentCount = this.insertedCountByItem[item.id_item] || 0;
          if (currentCount >= limit) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome || '—', error_line: this.$t('notasFiscais.insertEquipment.limitReached', { inserted: limit, limit }) });
            hasError = true;
            continue;
          }
          const descricaoItem = (item.x_prod || '').toString().trim();
          const idTipo = this.getTipoEquipamentoIdFromLineDescription(descricaoItem) || this.getTipoEquipamentoIdFromLineDescription(tipoName);
          const idEmpresa = this.resolveIdEmpresaFromCell(empresaCell);
          if (!nome) {
            resultRows.push({ line_number: i + 1, nome_equipamento: '—', error_line: this.$t('notasFiscais.uploadCsvEquipments.errorNameRequired') });
            hasError = true;
            continue;
          }
          if (!idTipo) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: this.$t('notasFiscais.uploadCsvEquipments.errorTypeNotFound', { tipo: tipoName }) });
            hasError = true;
            continue;
          }
          if (!idEmpresa) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: this.$t('notasFiscais.uploadCsvEquipments.errorCompanyNotFound') });
            hasError = true;
            continue;
          }
          try {
            const idNotaFiscalCsv = this.selectedNota && this.selectedNota.id_nota_fiscal;
            const insertRes = await apiController.request(apiController.endpoints.insertEquipamento, {
              data: {
                nome_equipamento: nome,
                id_tipo_equipamento: idTipo,
                numero_serie: numeroSerie || null,
                id_empresa: idEmpresa,
                id_status_equipamento: 0,
                ativo: 0,
                id_nota_fiscal: idNotaFiscalCsv || null
              },
              silent: true
            });
            if (insertRes.data && insertRes.data.erro) {
              resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: insertRes.data.mensagem || this.$t('notasFiscais.insertEquipment.error') });
              hasError = true;
              continue;
            }
            const idEquipamento = insertRes.data && insertRes.data.id_equipamento;
            if (idEquipamento) {
              const linkRes = await apiController.request(apiController.endpoints.insertNotafiscalitemequipamento, {
                data: { id_item: item.id_item, id_equipamento: idEquipamento },
                silent: true
              });
              if (linkRes.data && linkRes.data.erro) {
                resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: linkRes.data.mensagem || this.$t('notasFiscais.insertEquipment.error') });
                hasError = true;
                continue;
              }
            }
            this.insertedCountByItem = { ...this.insertedCountByItem, [item.id_item]: (this.insertedCountByItem[item.id_item] || 0) + 1 };
            totalInserted++;
            resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: '' });
          } catch (err) {
            resultRows.push({ line_number: i + 1, nome_equipamento: nome, error_line: (err.response && err.response.data && err.response.data.mensagem) || err.message || this.$t('notasFiscais.insertEquipment.error') });
            hasError = true;
          }
        }
        this.uploadCsvResult = { error: hasError, result: resultRows, arqlog: '' };
        this.uploadCsvResultDialog = true;
        this.closeUploadCsvDialog();
        if (totalInserted > 0) EventBus.$emit('show-success', { message: this.$t('notasFiscais.uploadCsvEquipments.successCount', { count: totalInserted }) });
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.uploadCsvLoading = false;
      }
    },
    openDownloadQRDialog() {
      this.downloadQRDialogOpen = true;
    },
    closeDownloadQRDialog() {
      this.downloadQRDialog = false;
      this.qrCodeQuantity = 1;
      this.qrCodeColumns = 3;
      if (this.$refs.downloadQRForm) {
        this.$refs.downloadQRForm.resetValidation();
      }
    },
    qrCodeQuantityRules() {
      return [
        (v) => !!v || (this.$t('equipment.qrcode.quantityRequired')),
        (v) => (v && v > 0) || (this.$t('equipment.qrcode.quantityMin')),
        (v) => (v && Number.isInteger(v)) || (this.$t('equipment.qrcode.quantityInteger'))
      ];
    },
    qrCodeColumnsRules() {
      return [
        (v) => v == null || v === '' || (Number.isInteger(v) && v >= 1 && v <= 8) || (this.$t('equipment.qrcode.columnsMin'))
      ];
    },
    downloadQRCodes() {
      this.$refs.downloadQRForm.validate();
      if (!this.downloadQRFormValidado) {
        return;
      }
      if (!this.qrCodeQuantity || this.qrCodeQuantity < 1) {
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipment.qrcode.invalidQuantity'),
          tipo: 'error'
        });
        return;
      }
      this.downloadingQRCodes = true;
      apiController.request(apiController.endpoints.downloadQrcodesequipamentos, {
        query: { quantity: this.qrCodeQuantity, format: 'sheet', columns: this.qrCodeColumns || 3 },
        config: { responseType: 'blob' },
        silent: true,
        onSuccess: (response) => {
          const blob = new Blob([response.data], { type: 'image/png' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `qrcodes_equipamentos_stickers_${Date.now()}.png`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.downloadingQRCodes = false;
          this.closeDownloadQRDialog();
          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipment.qrcode.downloadSuccess'),
            tipo: 'success'
          });
        },
        onError: (e) => {
          this.downloadingQRCodes = false;
          if (e.response && e.response.data) {
            if (e.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const errorData = JSON.parse(reader.result);
                  EventBus.$emit('show-alert', {
                    mensagem: errorData.mensagem || (this.$t('equipment.qrcode.downloadError')),
                    tipo: 'error'
                  });
                } catch (parseError) {
                  EventBus.$emit('show-alert', {
                    mensagem: this.$t('equipment.qrcode.downloadError'),
                    tipo: 'error'
                  });
                }
              };
              reader.readAsText(e.response.data);
            } else {
              EventBus.$emit('show-alert', {
                mensagem: e.response.data.mensagem || (this.$t('equipment.qrcode.downloadError')),
                tipo: 'error'
              });
            }
          } else {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    }
  }
};
</script>

<style scoped>
.chave-nfe-cell {
  display: block;
  max-width: 50vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
